import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_MODELS_QUERY_KEY } from './useGetModels';

import ModelsService, {
  FilterModelsDto,
  UpdateModelDto,
} from '@/services/ModelsService';

export function useUpdateModel(filters: FilterModelsDto) {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateModelDto }) =>
      ModelsService.updateModel(id, data),
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: GET_MODELS_QUERY_KEY(filters),
      });
    },
  });

  return { updateModel: mutateAsync, isUpdating: isPending };
}
